// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3z38T","text":"SelectPayment_text__2NCj9","title":"SelectPayment_title__3dj_3","btn":"SelectPayment_btn__20dge"};